import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

export const MatchCardLink = ({ matchInfo, className = '', children }) => {
    const canLinkToMC = useCallback(() => {
        return (
            !PULSE.app.common.team.isPlaceholderTeam(matchInfo.homeTeamPid) &&
            !PULSE.app.common.team.isPlaceholderTeam(matchInfo.awayTeamPid)
        );
    }, [matchInfo]);

    if (canLinkToMC()) {
        return (
            <a
                href={PULSE.app.common.url.getMatchURL(matchInfo)}
                className={`fb-match ${className}`}
                aria-label={PULSE.app.common.matchAriaLabel(matchInfo)}
            >
                {children}
            </a>
        );
    }

    return (
        <span className={`fb-match ${className} fb-match--no-link`}>
            {children}
        </span>
    );
};

MatchCardLink.propTypes = {
    matchInfo: PropTypes.object.isRequired,
    className: PropTypes.string,
    children: PropTypes.array
};
